import shiftAppearanceComponentUrl from './shiftAppearanceComponent.html';
class ShiftAppearanceCtrl {
  constructor(
    Authentication,
    PersonaCollection,
    Utils,
    ShiftUtils,
    TagsService,
    toTimeFilter,
    sdk
  ) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      PersonaCollection,
      Utils,
      ShiftUtils,
      TagsService,
      toTimeFilter,
      sdk,
    });
  }

  $onInit() {
    this.SHIFT_BLOCK_SOURCES = { ...this.sdk('constants').SHIFT_BLOCK_SOURCES };
    this.tabs = ['day', 'week', 'month'];
    this.activeTab = 'week';
    this.getShiftAppearanceToDisplay = this.sdk('helpers/getShiftAppearanceToDisplay');
    const decimalFormat = this.Utils.getDecimalFormat();

    this.sourcesLabels = {
      [this.SHIFT_BLOCK_SOURCES.TIME]: 'Time',
      [this.SHIFT_BLOCK_SOURCES.DURATION]: 'Duration',
      [this.SHIFT_BLOCK_SOURCES.ASSIGNEE]: 'Employee name',
      [this.SHIFT_BLOCK_SOURCES.POSITION]: 'Position',
      [this.SHIFT_BLOCK_SOURCES.LOCATION]: 'Location',
      [this.SHIFT_BLOCK_SOURCES.TAG]: 'Tag',
    };

    this.defaultsMap = {
      [this.SHIFT_BLOCK_SOURCES.TIME]: `${this.toTimeFilter(
        new Date('2017/12/23 09:00')
      )} - ${this.toTimeFilter(new Date('2017/12/23 17:00'))}`,
      [this.SHIFT_BLOCK_SOURCES.DURATION]: this.Utils.getDisplayDuration(8 * 60, decimalFormat),
      [this.SHIFT_BLOCK_SOURCES.ASSIGNEE]: 'John Doe',
      [this.SHIFT_BLOCK_SOURCES.POSITION]: this.PersonaCollection.positions.length
        ? this.Utils.sortBy(this.PersonaCollection.positions, 'id')[0].name
        : 'Position',
      [this.SHIFT_BLOCK_SOURCES.LOCATION]: this.PersonaCollection.locations.length
        ? this.Utils.sortBy(this.PersonaCollection.locations, 'id')[0].name
        : 'Location',
      [this.SHIFT_BLOCK_SOURCES.LOCATION]: this.PersonaCollection.locations.length
        ? this.Utils.sortBy(this.PersonaCollection.locations, 'id')[0].name
        : 'Location',
      [this.SHIFT_BLOCK_SOURCES.TAG]: this.PersonaCollection.tags.length
        ? this.Utils.sortBy(this.PersonaCollection.tags, 'id')[0].name
        : 'Tag',
    };

    if (!this.preferences.week.thirdLine) {
      this.preferences.week.thirdLine = [];
    }

    if (!this.preferences.day.thirdLine) {
      this.preferences.day.thirdLine = [];
    }

    if (!this.preferences.month.fourthLine) {
      this.preferences.month.fourthLine = [];
    }
  }

  $onChanges() {
    if (this.activeTab) {
      this.refreshSources();
    }
  }

  get activeTab() {
    return this._activeTab;
  }

  set activeTab(value) {
    this._activeTab = value;
    this.refreshSources();
  }

  refreshSources() {
    if (this.TagsService.isTagFeatureHidden) {
      delete this.SHIFT_BLOCK_SOURCES[this.SHIFT_BLOCK_SOURCES.TAG];
    }

    this.sources = Object.keys(this.SHIFT_BLOCK_SOURCES);
    this.disabledSources = this.sources.reduce(
      (acc, source) => ({
        ...acc,
        [source]: Object.values(this.preferences[this.activeTab]).some((arr) =>
          arr.some((item) => item === source)
        ),
      }),
      {}
    );
  }

  isSourceDisabled(source) {
    return this.disabledSources[source];
  }

  onSort() {
    if (this.form) {
      this.form.$setDirty();
    }

    this.refreshSources();
  }

  reset() {
    const defaults = this.getShiftAppearanceToDisplay(
      this.TagsService.isTagFeatureHidden,
      this.Authentication.user?.settings.defaultShiftAppearance
    );
    this.preferences[this.activeTab] = defaults[this.activeTab];
    this.onSort();
  }
}

export default {
  bindings: {
    preferences: '=',
    refreshCount: '<',
  },
  require: {
    form: '?^form',
  },
  controllerAs: 'ctrl',
  controller: ShiftAppearanceCtrl,
  templateUrl: shiftAppearanceComponentUrl,
};
